import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { FormatDate } from '../../utils/Tools';
import { IJudgingRound, IRoundDetails } from './JudgingCircles/JudgingCirlcesTypes';


interface IProps {
  round: IJudgingRound;
  rubrics: any;
  roundCategories: { id: number; name: string }[];
  roundDivisions: { id: number; name: string }[];
  roundTags: { id: number; name: string }[];
  roundJudgeTags: { id: number; name: string }[];
  allRounds: IJudgingRound[];
  index: number;
  openEdit: (round: IJudgingRound | null, index: number) => void;
  openRoundDetails: (round: IJudgingRound | null, index: number) => void;
}

const JudgingRound = (props:IProps) => {


  const [isFiltered, setIsFiltered] = useState(false);
  const [val, setVal] = useState<any>()

  useEffect(() => {
    setVal(props.round?.Values);
  }, [props.round?.Values])

  useEffect(() => {
    if (val) {
      if (
        val.FilterCategoryIds?.length > 0 ||
        val.FilterDivisionIds?.length > 0 ||
        val.FilterRoundIds?.length > 0 ||
        val.FilterTagIds?.length > 0 ||
        val.FilterJudgeTagIds?.length > 0 ||
        val.FilterMinAvgScore ||
        val.FilterMinAvgZScore
      ) {
        setIsFiltered(true);
      } else {
        setIsFiltered(false)
      }
    }
  }, [val])

  const getLabelsFromOptions = (
    ids: number[] | undefined,
    list: { id: number; name: string }[] | undefined
  ) => {
    if (!ids?.length || !list?.length) return [];
    return ids
      .map((id) => list.find((x) => x?.id === id)?.name)
      .filter(Boolean);
  };

  const mappedRounds = props.allRounds.map((round) => ({
    id: round.Id,
    name: round.Name,
  }));

  const categoryNames = getLabelsFromOptions(val?.FilterCategoryIds, props.roundCategories);
  const divisionNames = getLabelsFromOptions(val?.FilterDivisionIds, props.roundDivisions);
  const roundNames = getLabelsFromOptions(val?.FilterRoundIds, mappedRounds);
  const tagNames = getLabelsFromOptions(val?.FilterTagIds, props.roundTags);
  const judgeTagNames = getLabelsFromOptions(val?.FilterJudgeTagIds, props.roundJudgeTags);


  return (
    <>
      {props.round
        ?
        <div className="judging-round soft-border hover-shadow">
          <div className="title">
            <h3>{props.round.Name}</h3>
            {props.round.IsSubround
              &&
              <i className="fas fa-sort-size-down text-info" title='This is a subround'></i>
            }
            {isFiltered
              &&
              <i className="fas fa-filter text-info" title='This round has a filter'></i>
            }


          </div>
          <div className="round-details-scroll">
          <div>Round Value: {props.round.RoundValue}</div>
          {props.round.Values.Hidden && <div className='text-danger strong'><i className='fad fa-eye-slash'></i> Hidden in Online Judging</div>}
          {props.round.Values.IsPeerReview && <div className='text-info strong'><i className='fad fa-users'></i> Peer Review</div>}
          {props.round.Values.IsCoverageJudging && <div className='text-info strong' data-testid="coverage-round-badge"><i className='fad fa-layer-plus'></i> Coverage Judging · accept {props.round.Values.CoverageScoresToAccept || 0}, assign {props.round.Values.CoverageJudgesToAssign || 0}</div>}
          {props.round.Values.IsCoverageJudging && <CoverageLocks roundId={props.round.Id} />}
          {props.round.Values.UseJudgeGroups && <div><i className='fad fa-users'></i> Judge Groups</div>}
          {props.round.Values.AllowJudgesToRequestMoreWork && <div><i className='fad fa-user-plus'></i> Judges can Request More Work</div>}
          {(props.round.Values.SchedulesInterviews === true)
            &&
            <>
              <div><i className='fad fa-calendar-day'></i> Interviews Scheduled</div>
              {props.round.Values.StartDate
                &&
                <div >Judging Starts: {props.round.Values.StartDate} at {props.round.Values.StartTime}</div>
              }
              {props.round.Values.BreakStart1
                &&
                <div >Break: {props.round.Values.BreakStart1} to {props.round.Values.BreakEnd1}</div>
              }
              {props.round.Values.EndDate
                &&
                <div>Judging Ends: {props.round.Values.EndDate} at {props.round.Values.EndTime}</div>

              }
            </>
          }

        {props.round.Values.useRubric > 0 && <div><i className='fad fa-check-square'></i> Specifies Rubric</div>}
          {
            props.round.Values.useRubric && props.rubrics && <div>Rubric: {props.rubrics[props.round.Values.useRubric]}</div>
          }
          {isFiltered
            && <div>
              <div>Filtered by:</div>
              <div className='judging-round-filter-details'>
                {judgeTagNames.length > 0 && <div>Judge Tag: {judgeTagNames.join(', ')}</div>}
                {categoryNames.length > 0 && <div>Category: {categoryNames.join(', ')}</div>}
                {divisionNames.length > 0 && <div>Division: {divisionNames.join(', ')}</div>}
                {tagNames.length > 0 && <div>Project Tag: {tagNames.join(', ')}</div>}
                {roundNames.length > 0 && <div>Previous Round: {roundNames.join(', ')}</div>}
                {val?.FilterMinAvgScore && <span>Minimum Average Score</span>}
                {val?.FilterMinAvgZScore && <span>Minimum Average Z-Score</span>}
              </div>
            </div>
          } </div>


          <div className="off-bottom-right">
            <span
              onClick={() => props.openRoundDetails(props.round, props.index)}
              className={`hover-info open-${props.round.Name}`}
              data-testid="open-round-details"
            >
              <i className="fad fa-eye fa-3x"></i>
            </span>
            <span
              onClick={() => props.openEdit(props.round, props.index)}
              className={`hover-success edit-${props.round.Name}`}
              data-testid="open-round-edit"
              >
              <i className="fad fa-edit fa-3x"></i>
            </span>
          </div >
        </div >
        :
        <div className="judging-round soft-border hover-shadow">
          <div className="title">
            <h3>Create a New Round</h3>
          </div>
          <p>Round Value: 0-100</p>
          <div className="off-bottom-right create-round-btn">
            <span
              onClick={() => props.openEdit(null, props.index)}
              className="hover-success"
            >
              <i className="fad fa-plus-circle fa-3x"></i>
            </span>
          </div>
        </div >

      }
    </>
  )
}

const CoverageLocks = ({ roundId }: { roundId?: number }) => {
  const [locks, setLocks] = useState<any[]>([]);
  const [loaded, setLoaded] = useState(false);

  const load = () => {
    if (!roundId) return;
    store.server
      .getApiQuiet<ServerResponse<any[]>>(`../JudgingManagement/CoverageLocks?roundId=${roundId}`)
      .then((x) => {
        if (x.Success) setLocks(x.Value || []);
        setLoaded(true);
      });
  };

  useEffect(() => {
    load();
    const handle = window.setInterval(load, 15000);
    // roundId is the only input. The interval drops locks that have expired.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => window.clearInterval(handle);
  }, [roundId]);

  const clearLock = (projectIntId: number) => {
    store.server
      .postApi<ServerResponse<boolean>>('../JudgingManagement/ClearCoverageLock', { roundId, projectIntId })
      .then((x) => {
        if (x.Success) load();
        else toast.error(x.Message || 'Could not clear that lock.');
      })
      .catch(() => toast.error('Could not clear that lock.'));
  };

  return (
    <div data-testid="coverage-locks">
      <div className="strong">Rubrics open now</div>
      <div>Each button clears that entry only.</div>
      {loaded && locks.length === 0 && <div>No judge has a rubric open.</div>}
      {locks.map((lock) => {
        const projectIntId = lock.ProjectIntId ?? lock.projectIntId;
        const code = lock.ProjectCode ?? lock.projectCode;
        const title = lock.Title ?? lock.title;
        const judge = lock.JudgeName ?? lock.judgeName;
        const expires = lock.ExpiresAt ?? lock.expiresAt;
        return (
          <div key={projectIntId}>
            {code} {title} · {judge} · until {FormatDate(expires, 'time')}
            <button type="button" className="btn btn-default btn-xs bumper-left" onClick={() => clearLock(projectIntId)}>
              Clear lock
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default JudgingRound